import React, { useState } from "react";
import { Checkbox, Grid, Slider } from "@material-ui/core";
import { fabric } from "fabric";
import { useSelector } from "react-redux";

const HueOptions = ({ save, saveBack }) => {
  const _home = useSelector((state) => state.home);
  const [hue, setHue] = useState(0.5);

  const applyFilter = (index, filter) => {
    var obj = _home.currentCanvas.getActiveObject();
    if (obj) {
      obj.filters[index] = filter;
      obj.applyFilters();
      _home.currentCanvas.requestRenderAll();
    }
    if (_home.face === "front") {
      save();
    } else {
      saveBack();
    }
  };

  const applyFilterValue = (index, prop, value) => {
    var obj = _home.currentCanvas.getActiveObject();
    if (obj.filters[index]) {
      obj.filters[index][prop] = value;
      obj.applyFilters();
      _home.currentCanvas.requestRenderAll();
    }
    if (_home.face === "front") {
      save();
    } else {
      saveBack();
    }
  };

  const applyHue = (check) => {
    applyFilter(
      21,
      check &&
        new fabric.Image.filters.HueRotation({
          rotation: parseFloat(hue),
        })
    );
  };

  const handleValueChange = (event, newValue) => {
    setHue(newValue);
    applyFilterValue(21, "rotation", parseFloat(newValue));
  };
  return (
    <div>
      Hue:
      <Checkbox
        color="primary"
        onClick={(e) => applyHue(e.target.checked)}
        inputProps={{ "aria-label": "secondary checkbox" }}
      />
      <Grid container spacing={2} alignItems="center">
        <Grid item xs>
          <Slider
            step={0.01}
            min={0}
            max={1}
            value={typeof hue === "number" ? hue : 0}
            onChange={handleValueChange}
            aria-labelledby="input-slider"
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default HueOptions;
